import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { FaEye, FaGamepad, FaUsers, FaRupeeSign } from "react-icons/fa";

export default function Conflictgame() {
  const [challenge, setChallenge] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  const backendUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BACKEND_LOCAL_API
      : process.env.REACT_APP_BACKEND_LIVE_API;

  const limit = 10;
  const [pageNumber, setPageNumber] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(0);

  const handlePageClick = (data) => {
    setPageNumber(data.selected + 1);
  };

  const Allchallenge = async () => {
    try {
      setLoading(true);

      const access_token = localStorage.getItem("cejoraTokenDash");

      const { data } = await axios.get(
        `${backendUrl}admin/challange/dashboard/all?page=${pageNumber}&_limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        },
      );

      setChallenge(data.status || []);
      setNumberOfPages(data.totalPages || 0);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    Allchallenge();
  }, [pageNumber]);

  const getStatusBadge = (status) => {
    switch (status?.toLowerCase()) {
      case "completed":
        return "success";
      case "running":
        return "warning";
      case "cancelled":
        return "danger";
      default:
        return "info";
    }
  };

  const filteredGames = challenge.filter(
    (game) =>
      game?.Created_by?.Name?.toLowerCase().includes(search.toLowerCase()) ||
      game?.Accepetd_By?.Name?.toLowerCase().includes(search.toLowerCase()) ||
      game?._id?.toLowerCase().includes(search.toLowerCase()),
  );

  const totalAmount = challenge.reduce(
    (acc, curr) => acc + Number(curr.Game_Ammount || 0),
    0,
  );

  return (
    <div className="container-fluid py-4 dashboard-bg">
      {/* Header */}
      <div className="card header-card border-0 mb-4">
        <div className="card-body d-flex justify-content-between align-items-center">
          <div>
            <h3 className="fw-bold text-white mb-1">
              <FaGamepad className="me-2 text-info" />
              Game Management
            </h3>
            <small className="text-light opacity-75">
              Manage and monitor all challenges
            </small>
          </div>

          <div className="text-end">
            <h4 className="text-white mb-0">{challenge.length}</h4>
            <small className="text-light">Games Found</small>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="row g-4 mb-4">
        <div className="col-md-4">
          <div className="dashboard-card">
            <h6>Total Games</h6>
            <h2>{challenge.length}</h2>
          </div>
        </div>

        <div className="col-md-4">
          <div className="dashboard-card">
            <h6>Total Players</h6>
            <h2>
              <FaUsers className="me-2" />
              {challenge.length}
            </h2>
          </div>
        </div>

        <div className="col-md-4">
          <div className="dashboard-card">
            <h6>Total Amount</h6>
            <h2>
              <FaRupeeSign />
              {totalAmount}
            </h2>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="card main-card border-0">
        <div className="card-body">
          <div className="mb-4">
            <input
              type="text"
              className="form-control search-box"
              placeholder="Search by Player Name or Game ID..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-info" />
            </div>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table custom-table align-middle">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Players</th>
                      <th>Game ID</th>
                      <th>Amount</th>
                      <th>Status</th>
                      <th>Game Type</th>
                      <th>Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredGames.map((game, index) => (
                      <tr key={game._id}>
                        <td>{index + 1}</td>

                        <td>
                          <div className="d-flex align-items-center">
                            <div className="player-avatar">
                              {game?.Created_by?.Name?.charAt(0)}
                            </div>

                            <div className="ms-3">
                              <div className="fw-bold text-white">
                                {game?.Created_by?.Name}
                              </div>

                              <small className="text-secondary">
                                VS {game?.Accepetd_By?.Name || "Waiting"}
                              </small>
                            </div>
                          </div>
                        </td>

                        <td>
                          <small className="text-info">{game._id}</small>
                        </td>

                        <td>
                          <span className="fw-bold text-success">
                            ₹{game.Game_Ammount}
                          </span>
                        </td>

                        <td>
                          <span
                            className={`badge bg-${getStatusBadge(
                              game.Status,
                            )}`}
                          >
                            {game.Status}
                          </span>
                        </td>

                        <td>{game.Game_type}</td>

                        <td>{new Date(game.createdAt).toLocaleDateString()}</td>

                        <td>
                          <Link
                            to={`/view/${game._id}`}
                            className="btn btn-outline-info btn-sm"
                          >
                            <FaEye className="me-1" />
                            View
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <ReactPaginate
                previousLabel={"←"}
                nextLabel={"→"}
                pageCount={numberOfPages}
                onPageChange={handlePageClick}
                containerClassName="pagination justify-content-center mt-4"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
